export default "__VITE_PUBLIC_ASSET__32e21839__"